<div class="contact-box-wrapper">
  <div class="contact-phone-dropdowns">
    <label>{{ 'searchContact.nameType' | translate }}</label>
  </div>
  <mat-form-field appearance="outline">
    <mat-select
      class="select add-contact-dropdown"
      [value]="selectedName"
      [placeholder]="selectedName"
      (selectionChange)="nameSelection($event)"
      >
      @for (item of nameCatalog; track item) {
        <mat-option [ngClass]="'select-option'" [value]="item.value">
          {{ item.label | uppercase }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="contact-phone-dropdowns">
    <label>{{ 'searchContact.phoneType' | translate }}</label>
  </div>
  <mat-form-field appearance="outline">
    <mat-select
      class="select add-contact-dropdown"
      [value]="selectedPhone"
      [placeholder]="selectedPhone"
      (selectionChange)="phoneSelection($event)"
      >
      @for (item of phoneCatalog(); track item) {
        <mat-option [ngClass]="'select-option'" [value]="item.value">
          {{ item.label | uppercase }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
